import { ShopProductLine } from './shopProductLine.interface';
export interface ShopCategory {
    _id: string;
    icon: string;
    text: string;
    orderNumber: number;
    productLineNames: ShopProductLine[];
}
